import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../../../firebase';
import SingleRoundHostcupFirebase from './SingleRoundHostcupFirebase';

function AllRoundsHostcup({id}) {

    const [rounds, setRounds] = useState([]);

    useEffect(() => {

        try {
            const roundsRef = firestore.collection("hostcup").doc(id).collection("rounds");
            roundsRef.orderBy("round").onSnapshot(({docs}) => {
                const rounds = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setRounds(rounds);
            })
        } catch (error) {
            
        }

    }, [id])


    return (
        <div>
            {rounds?.map((round, index) => {
                return (
                    <div key={index} className="mt-2">
                        <Link className="my-3" to={`/hostcupround/admin/${id}?runde=${round.id}`}>Runde {round?.round}</Link>
                        <SingleRoundHostcupFirebase id={id} roundId={round.id} />
                    </div>
                )
            })}
        </div>
    )

}
export default AllRoundsHostcup